import { useEffect, useRef, useState } from 'react'
import { useDispatch } from 'react-redux'

import { sendFacebookParamsAction } from 'root-redux/actions/user'

import { useCookieConsentAnswer } from 'hooks/useCookieConsentAnswer'

import {
  createFacebookParams,
  persistFacebookParams,
} from 'helpers/createFacebookParams'

export const useFacebookParamsSync = ({
  shouldCreateParams,
  shouldSync,
}: {
  shouldCreateParams: boolean
  shouldSync: boolean
}): void => {
  const dispatch = useDispatch()
  const { canUseAdvertising } = useCookieConsentAnswer()
  const [facebookParams] = useState(() => createFacebookParams())
  const hasSynced = useRef(false)

  useEffect(() => {
    if (
      hasSynced.current ||
      !shouldSync ||
      (shouldCreateParams && !canUseAdvertising)
    ) {
      return
    }

    const persistedFacebookParams = shouldCreateParams
      ? persistFacebookParams(facebookParams)
      : undefined

    hasSynced.current = true
    dispatch(sendFacebookParamsAction(persistedFacebookParams))
  }, [
    canUseAdvertising,
    dispatch,
    facebookParams,
    shouldCreateParams,
    shouldSync,
  ])
}
